import { useRequest } from 'ahooks';
import { fetchAssociationUsers } from '@/services/user';

export default () => {
  return useRequest(fetchAssociationUsers, {
    manual: true,
  });
};
